import script from "./InCart.vue?vue&type=script&setup=true&lang=js"
export * from "./InCart.vue?vue&type=script&setup=true&lang=js"

import "./InCart.vue?vue&type=style&index=0&id=45951427&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45951427"]])

export default __exports__